export enum MissionType {
  LEVEL_COUNT = 1,
  GMONEY_COUNT = 2, // 체크
  SEND_MESSAGE_TO_DIBSED_ME_USER = 3,
  USE_CASH = 4, // 체크
  TOTAL_ATTEND = 5,
  CONTINUE_ATTEND = 6,
  ALL_DAILY_MISSION_COMPLETE = 7,
  ALL_WEEKLY_MISSION_COMPLETE = 8,
  CHANGE_NICKNAME = 9,
  OPEN_GIFT_BOX = 10, // 체크

  BUY_PICK = 11, // 체크
  PUBLISH_PICK = 12, // 체크
  JOIN_CLUB = 13,
  RECEIVE_DIBS = 14,
  WIN_TIE_ODDS = 15,
  GAIN_GMONEY_FROM_BET = 16,
  TOTAL_BET_COUNT = 17,
  USE_GMONEY_FOR_BET = 18, // 체크

  WIN_COUNT = 19,
  WINNING_STREAK = 20,

  CHANGE_EMBLEM = 30,
  UPGRADE_COAT = 31,
  UPGRADE_ARENA = 32,
  UPGRADE_STADIUM = 33,
  MEMBER_COUNT = 34,
  CLUB_GMONEY_COUNT = 35,
  SET_MAX_WIN_MONEY = 36,
  SEND_CLUB_NOTE = 37,
  ONGOING_BETTING_COUNT = 38,
  PROVIDE_SPORT = 39,
  CHANGE_BETTYPE = 40,
  CHANGE_REFUND_RATE = 41,

  TOP_HIT_MONEY = 101, // 101 = 최고 적중머니 n 달성
  TOP_HIT_RATE = 102, // 102 = 최고 적중배당 n배 달성
  SOCCER_BET_COUNT = 103, // 103 = 축구 종목 베팅 n회 달성
  BASKETBALL_BET_COUNT = 104, // 104 = 농구 종목 베팅 n회 달성
  BASEBALL_BET_COUNT = 105, // 105 = 야구 종목 베팅 n회 달성
  VOLLEYBALL_BET_COUNT = 106, // 106 = 배구 종목 베팅 n회 달성
  ICE_HOCKEY_BET_COUNT = 107, // 107 = 아이스하키 종목 베팅 n회 달성
  PRODUCT_84_BUY = 108, // 108 =  ItemID 84(스킨) 구매
  PRODUCT_85_BUY = 109, // 109 =  ItemID 85(스킨) 구매
  PRODUCT_86_BUY = 110, // 110 =  ItemID 86(스킨) 구매
  PRODUCT_87_BUY = 111, // 111 =  ItemID 87(스킨) 구매
}
